<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<div style="position: relative; margin-right: 20px; margin-left: 10px" class="mb-3">
			<v-layout>
				<v-flex xs7 style="padding: 5px">
					<div class="mb-2" style="margin-left: 20px">
						<strong class="mr-2" style="font-size: 17px">{{project.agency}} {{attributeInfo}}</strong>
					</div>
					<div class="mb-2" style="margin-left: 20px; font-size: 15px">
						<strong class="mr-2" style="font-size: 15px">Autor:</strong> {{project.author}}
					</div>
					<div class="mb-2" style="margin-left: 20px; font-size: 15px">
						<strong class="mr-2" style="font-size: 15px">Nazwa projektu:</strong> {{project.title}}
					</div>
					<div class="mb-2" style="margin-left: 20px; font-size: 15px">
						<strong class="mr-2" style="font-size: 15px">Numer projektu:</strong>
						{{project.agencyProjectCode}}
					</div>
				</v-flex>
				<v-flex xs5 style="padding: 5px">
					<v-tooltip left max-width="1000px">
						<template v-slot:activator="{ on }">
							<div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: flex-end" class="mr-2">
								<v-icon small v-on="on" style="padding-right: 10px"
									v-if="project.agencyProjectStatus === 'ANNULLED'">info</v-icon>
								<strong v-if="getStatus" style="font-size: 16px">Status: {{getStatus}}</strong>
							</div>
						</template>
						<div>
							<b>Projekt anulowany</b>
						</div>
						<span>{{ currentAnnulationCause }}</span>
					</v-tooltip>
					<div style="display: flex; flex-direction: row; justify-content: flex-end">
						<v-btn class="grey" @click="hideProject"
							v-if="projectCanBeHidden">Ukryj
						</v-btn>
						<v-btn class="grey" @click="undoHideProject"
							v-if="projectHidingCanBeUndone">Cofnij ukrycie
						</v-btn>
						<v-btn class="grey darken-1" @click="archiveProject"
							v-if="projectCanBeArchived">Archiwizuj
						</v-btn>
						<v-btn class="grey darken-1" @click="undoArchiveProject"
							v-if="projectArchivingCanBeUndone">Cofnij archiwizację
						</v-btn>
						<v-btn class="warning" @click="correction.dialog = true" v-if="changesCanBeRequested()">
							Do poprawki
						</v-btn>
						<v-btn class="error" @click="undoRequestChanges()" v-if="changesRequestCanBeUndone()">
							Cofnij oddanie do poprawki
						</v-btn>
					</div>
					<div style="display: flex; flex-direction: row; justify-content: flex-end">
						<v-btn class="accent" @click="sendMailToAgency()">
							<v-icon color="white" left>mail</v-icon>
							Wyślij email
						</v-btn>
						<v-btn color="accent" dark @click="viewProject">
							<v-icon color="white" left>description</v-icon>
							Podgląd
						</v-btn>
						<v-btn color="accent" dark @click="moveToHistory">
							<v-icon color="white" left>history</v-icon>
							Historia
						</v-btn>
					</div>
					<div style="display: flex; flex-direction: row; justify-content: flex-end">
						<v-btn class="warning" @click="undoAnnulation"
							v-if="canUndoCancelAgencyProject">
							<v-icon color="white" left>assignment_return</v-icon>
							Cofnij anulowanie projektu
						</v-btn>
						<v-btn class="error" @click="annulation.dialog = true"
							v-if="canCancelAgencyProject">
							<v-icon color="white" left>cancel</v-icon>
							Anuluj projekt
						</v-btn>
						<v-btn color="accent" dark @click="undoFinishProject"
							v-if="projectFinishingCanBeUndone">
							<v-icon color="white" left>assignment_return</v-icon>
							Cofnij zakończenie projektu
						</v-btn>
						<v-btn color="accent" dark @click="finishProject"
							v-if="projectCanBeFinished">
							<v-icon color="white" left>assignment_turned_in</v-icon>
							Zakończ projekt
						</v-btn>
					</div>
				</v-flex>
			</v-layout>
		</div>

		<router-link :to="{ path: 'correspondence'}" replace>
			<v-btn>Korespondencja</v-btn>
		</router-link>
		<router-link :to="{ path: 'amounts'}" replace>
			<v-btn>Kwoty</v-btn>
		</router-link>
		<router-link :to="{ path: 'monitoring'}" replace>
			<v-btn>Monitoring</v-btn>
		</router-link>
		<template v-if="!hasEditAccess && !project.reportApproved">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<div v-on="on" class="d-inline-block">
						<v-btn disabled>Sprawozdanie końcowe</v-btn>
					</div>
				</template>
				<span>Sprawozdanie nie zostało jeszcze zatwierdzone</span>
			</v-tooltip>
		</template>
		<template v-else>
			<router-link :to="{ path: 'final-report'}" replace>
				<v-btn>Sprawozdanie końcowe</v-btn>
			</router-link>
		</template>
		<router-view v-bind:project="project" v-on:refresh="refresh"/>

		<v-dialog v-model="correction.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Przekazanie projektu do poprawek</span>
				</v-card-title>
				<v-card-text>
					<v-text-field
						browser-autocomplete="off"
						data-vv-name="correctionCause"
						data-vv-as="Powód przekazania do poprawek"
						label="Powód przekazania do poprawek"
						:error-messages="vErrors.collect('correctionCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="correction.cause"
						aria-label="correction cause">
					</v-text-field>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="detailedCorrectionCause"
						data-vv-as="Opis szczegółowy"
						label="Opis szczegółowy"
						v-model="correction.detailedCause"
						:error-messages="vErrors.collect('detailedCorrectionCause')"
						v-validate="'required'"
						aria-label="detailed correction cause">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="correction.cause !== '' && correction.detailedCause !== ''"
						color="blue darken-1"
						flat
						@click="requestChanges">
						Oddaj do poprawek
					</v-btn>
					<v-btn
						color="blue"
						@click="correction.dialog = false">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="annulation.dialog" persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">Anulowanie projektu</span>
				</v-card-title>
				<v-card-text>
					<v-textarea
						browser-autocomplete="off"
						data-vv-name="annulationCause"
						data-vv-as="Powód anulowania projektu"
						label="Powód anulowania projektu"
						:error-messages="vErrors.collect('annulationCause')"
						v-validate="'required'"
						@keydown="onKeyDownEvent"
						v-model="annulation.cause"
						aria-label="annulation cause">
					</v-textarea>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						v-if="annulation.cause !== ''"
						color="blue darken-1"
						flat
						@click="requestAnnulation">
						Anuluj projekt
					</v-btn>
					<v-btn
						color="blue"
						@click="annulation.dialog = false">
						Zamknij
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import {AgencyProject} from "@/api/generated/AgencyProject";

	export default {
		name: "AgencyProjectPanelView",

		data() {
			return {
				project: {
					correspondenceRemarks: null, 
					amountRemarks: null,
					finalReportRemarks: null,
					monitoringRemarks: null
				},
				correction: {
					dialog: false,
					cause: '',
					detailedCause: ''
				},
        annulation: {
          dialog: false,
          cause: '',
        },
        currentAnnulationCause: {}
			};
		},

		created() {
			this.refresh();
			this.$store.commit("loadAgencyProjectPanelPermissions", {context: this, projectId: this.$route.params.projectId});
		},

		watch: {
			"correction.dialog": function (val) {
				if (!val) {
					this.correction.cause = '';
					this.correction.detailedCause = '';
				}
			},

      "annulation.dialog": function(val) {
        if (!val) {
          this.annulation.cause = '';
        }
      }
		},

		computed: {
			hasEditAccess () {
				return this.project.supervisor || this.roles.isAdministrator() || this.roles.isLocalAdministrator();
			},

			projectCanBeHidden () {
				return !this.project.hidden && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},

			projectHidingCanBeUndone () {
				return this.project.hidden && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},

			projectCanBeArchived () {
				return !this.project.archived && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},

			projectArchivingCanBeUndone () {
				return this.project.archived && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},
			hasAgencyProjectPanelSupervisorModificationAccess(){
				return this.$store.state.agencyProjectPanelPermissions.hasAgencyProjectPanelSupervisorModificationAccess;
			},
			canCancelAgencyProject(){
				return this.project.agencyProjectStatus === 'APPROVED' && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},
			canUndoCancelAgencyProject(){
				return this.project.agencyProjectStatus === 'ANNULLED' && this.hasAgencyProjectPanelSupervisorModificationAccess;
			},

      projectCanBeFinished() {
        return this.project.agencyProjectStatus !== 'FINISHED' &&
            this.project.agencyProjectStatus !== 'ANNULLED' &&
            this.hasAgencyProjectPanelSupervisorModificationAccess;
      },

      projectFinishingCanBeUndone() {
        return this.project.agencyProjectStatus === 'FINISHED' && this.hasAgencyProjectPanelSupervisorModificationAccess;
      },

			attributeInfo () {
				if (this.project.hidden && this.project.archived) return "(Projekt ukryty, archiwizowany)";
				else if (this.project.hidden) return "(Projekt ukryty)";
				else if (this.project.archived) return "(Projekt archiwizowany)";
				return "";
			},

      getStatus () {
        if (this.project.agencyProjectStatus === 'NEW') return 'nowy';
        else if (this.project.agencyProjectStatus === 'SUBMITTED') return 'wysłany';
        else if (this.project.agencyProjectStatus === 'REJECTED') return 'odrzucony';
        else if (this.project.agencyProjectStatus === 'APPROVED') return 'zatwierdzony do realizacji';
        else if (this.project.agencyProjectStatus === 'AWAITING_CORRECTION') return 'oddany do poprawki';
        else if (this.project.agencyProjectStatus === 'PROJECT_CHANGES_REQUESTED') return 'oddany do poprawki';
        else if (this.project.agencyProjectStatus === 'FINISHED') return 'zakończony';
        else if (this.project.agencyProjectStatus === 'ANNULLED') return 'anulowany';
        else return null;
      },
		},

		methods: {
			refresh() {
				this.loadData();
			},

			loadData() {
				AgencyProject.getBasicData(this, this.$route.params.projectId, successResponse => {
						this.project = successResponse;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych projektu", errorResponse);
					});

        AgencyProject.getAnnulationCause(this, this.$route.params.projectId, successResponse => {
            this.currentAnnulationCause = successResponse.body;
          }, errorResponse => {
            this.$messagesBus.$emit("error", "Nie udało się załadować powodu anulacji projektu", errorResponse);
        });
			},

			viewProject() {
				this.$router.openInNewTab("/view/agency-contest/" + this.project.contestId + "/project/" + this.project.agencyId + "/" + this.project.id);
			},

			moveToHistory() {
				this.$router.push("/app/agency-project/" + this.$route.params.projectId + "/history");
			},

			finishProject() {
				this.$confirm("Czy na pewno chcesz oznaczyć projekt jako zakończony?", {
					icon: "warning",
					title: "Zakończenie projektu",
					color: "primary",
					width: 500,
				})
					.then(response => {
						if (response) {
							AgencyProject.putFinish(this, this.project.id, successResponse => {
									this.project.agencyProjectStatus = 'FINISHED';
									this.$messagesBus.$emit("success", "Pomyślnie zakończono projekt", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zakończyć projektu", errorResponse);
								});
						}
					});
			},

			undoFinishProject () {
				this.$confirm("Czy na pewno chcesz cofnąć zakończenie projektu?", {
					icon: "warning",
					title: "Cofnięcie zakończenia projektu",
					color: "primary",
					width: 500,
				})
					.then(response => {
						if (response) {
							AgencyProject.putUndoFinish(this, this.project.id, successResponse => {
									this.project.agencyProjectStatus = 'APPROVED';
									this.$messagesBus.$emit("success", "Pomyślnie cofnięto zakończenie projektu", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się cofnąć zakończenia projektu", errorResponse);
								});
						}
					});
			},

			hideProject () {
				this.$confirm("Czy na pewno chcesz ukryć projekt?", {
					icon: 'warning',
					title: 'Ukrycie projektu',
					color: 'primary',
					width: 500
				}).then((response) => {
					if (response) {
						AgencyProject.putHide(this, this.project.id, successResponse => {
								this.loadData();
								this.$messagesBus.$emit("success", "Projekt został pomyślnie ukryty", successResponse);
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się ukryć projektu", errorResponse);
							});
					}
				});
			},

			undoHideProject () {
				this.$confirm("Czy na pewno chcesz cofnąć ukrycie projektu?", {
					icon: 'warning',
					title: 'Cofnięcie ukrycia projektu',
					color: 'primary',
					width: 500
				}).then((response) => {
					if (response) {
						AgencyProject.putUndoHide(this, this.project.id, successResponse => {
								this.loadData();
								this.$messagesBus.$emit("success", "Ukrycie projektu zostało pomyślnie cofnięte", successResponse);
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się cofnąć ukrycia projektu", errorResponse);
							});
					}
				});
			},

			archiveProject () {
				this.$confirm("Czy na pewno chcesz archiwizować projekt?", {
					icon: 'warning',
					title: 'Archiwizacja projektu',
					color: 'primary',
					width: 500
				}).then((response) => {
					if (response) {
						AgencyProject.putArchive(this, this.project.id, successResponse => {
								this.loadData();
								this.$messagesBus.$emit("success", "Projekt został pomyślnie archiwizowany", successResponse);
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się archiwizować projektu", errorResponse);
							});
					}
				});
			},

			undoArchiveProject () {
				this.$confirm("Czy na pewno chcesz cofnąć archiwizację projektu?", {
					icon: 'warning',
					title: 'Cofnięcie archiwizacji projektu',
					color: 'primary',
					width: 500
				}).then((response) => {
					if (response) {
						AgencyProject.putUndoArchive(this, this.project.id, successResponse => {
								this.loadData();
								this.$messagesBus.$emit("success", "Archiwizacja projektu została pomyślnie cofnięta", successResponse);
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się cofnąć archiwizacji projektu", errorResponse);
							});
					}
				});
			},

			sendMailToAgency () {
				AgencyProject.getAgencyEmail(this, this.project.id, successResponse => {
						window.location.href = "mailto:" + successResponse.email;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać adresu e-mail", errorResponse);
					});
			},

			prepareCorrectionData () {
				return {
					correctionCause: this.correction.cause,
					detailedCorrectionCause: this.correction.detailedCause
				};
			},

      prepareAnnulationData () {
        return {
          annulationCause: this.annulation.cause,
        };
      },

      requestAnnulation() {
        AgencyProject.putRequestAnnulation(this, this.project.id, this.prepareAnnulationData(),
            successResponse => {
              this.annulation.dialog = false;
              this.loadData();
              this.$messagesBus.$emit("success", "Projekt został pomyślnie anulowany", successResponse);
            },
            errorResponse => {
              this.$messagesBus.$emit("error", "Nie udało się anulować projektu", errorResponse);
            });
      },

      undoAnnulation() {
        this.$confirm("Czy na pewno chcesz cofnąć anulowanie projektu?", {
          color: "blue",
          icon: "warning",
          title: "Cofnięcie anulowania projektu",
          width: 600,
        })
            .then(response => {
              if (response) {
                AgencyProject.putUndoRequestAnnulation(this, this.project.id, successResponse => {
                      this.loadData();
                      this.$messagesBus.$emit("success", "Anulowanie projektu zostało pomyślnie wycofane", successResponse);
                    },
                    errorResponse => {
                      this.$messagesBus.$emit("error", "Nie udało się wycofać anulowania projektu", errorResponse);
                    });
              }
            });
      },
      
			requestChanges () {
				AgencyProject.putRequestApprovedProjectCorrection(this, this.project.id, this.prepareCorrectionData(), successResponse => {
						this.correction.dialog = false;
						this.loadData();
						this.$messagesBus.$emit("success", "Projekt został pomyślnie oddany do poprawki", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się oddać projektu do poprawki", errorResponse);
					});
			},

			changesCanBeRequested () {
				return !this.project.hidden && !this.project.archived && this.project.agencyProjectStatus === 'APPROVED' && this.hasEditAccess;
			},

			changesRequestCanBeUndone () {
				return !this.project.hidden && !this.project.archived && this.project.agencyProjectStatus === 'PROJECT_CHANGES_REQUESTED' && this.hasEditAccess;
			},

			undoRequestChanges () {
				this.$confirm("Czy na pewno chcesz cofnąć oddanie projektu do poprawki?", {
					color: "blue",
					icon: "warning",
					title: "Cofnięcie oddania projektu do poprawki",
					width: 600,
				})
					.then(response => {
						if (response) {
							AgencyProject.putUndoRequestApprovedProjectCorrection(this, this.project.id, successResponse => {
									this.loadData();
									this.$messagesBus.$emit("success", "Oddanie projektu do poprawki zostało pomyślnie cofnięte", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się cofnąć oddania projektu do poprawki", errorResponse);
								});
						}
					});
			},

			onKeyDownEvent (evt) {
				if (this.correction.cause.length >= 255 && evt.keyCode >= 48 && evt.keyCode <= 90) evt.preventDefault();
			}
		},
	};
</script>

<style scoped>

</style>
